import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'http://localhost:3001/api',
    formatArchiveUrl: 'http://localhost:3000/',
};
